var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Grid, Typography, Box } from "@mui/material";
/**
 * Componente responsável por renderizar o header do formulário inserido no survey
 */
var SurveyFormHeader = function (_a) {
    var formData = _a.formData;
    if (!formData.title && !formData.description && !formData.logo) {
        return null;
    }
    return (_jsxs(Grid, __assign({ container: true, sx: {
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            gap: 3,
        } }, { children: [_jsx(Grid, __assign({ item: true, xs: 12, md: formData.logo ? 7 : 12 }, { children: formData.showTitle === undefined && (_jsxs(_Fragment, { children: [formData.title && (_jsx(Typography, __assign({ variant: "h4", gutterBottom: true, sx: { color: "white" } }, { children: formData.title }))), formData.description && (_jsx(Typography, __assign({ variant: "body1", sx: { color: "white" } }, { children: formData.description })))] })) })), formData.logo && (_jsx(Grid, __assign({ item: true, xs: 12, md: 4 }, { children: _jsx(Box, __assign({ sx: {
                        display: "flex",
                        justifyContent: { xs: "flex-start", md: "flex-end" },
                    } }, { children: _jsx("img", { src: formData.logo, alt: "Logo do formul\u00E1rio", style: {
                            width: formData.logoWidth || "300px",
                            height: formData.logoHeight || "200px",
                            objectFit: formData.logoFit || "contain",
                        } }) })) })))] })));
};
export default SurveyFormHeader;
